export { default } from './PagePlaces.vue'
